import React from 'react';
import { Stack, Paper } from '@mui/material';
import { Table, TableBody, TableContainer, TableHead, TableRow, Typography } from '@mui/material';
import Grid from '@mui/material/Grid';
import { AccordionSummary, AccordionDetails, Accordion } from '../shared/components/accordion';
import StyledTableRow from '../shared/components/styledTableRow';
import StyledTableCell from '../shared/components/styledTableCell';
import { GetDayJSValueFromUTCDate, GetFullPhoneNo, GetNoToCurrencyFormat } from '../utils/extensions/functionEx';
import { DATE_DISPLAY_FORMAT } from '../startups/apiConfig';

const CompletedNurseView = (props) => {
    const { expanded, completedNurses, handleAccordionChange } = props;

    return (

        <Accordion expanded={expanded === 'panelCompletedNurses'} onChange={handleAccordionChange('panelCompletedNurses')}>
            <AccordionSummary id="panel-completed-nurses">
                <Typography>Nurse Histories</Typography>
            </AccordionSummary>
            <AccordionDetails>
                <Stack spacing={1}>
                    <Grid container spacing={1}>
                        <Grid size={12}>
                            <TableContainer component={Paper} sx={{ maxHeight: '77vh' }}>
                                <Table stickyHeader sx={{ minWidth: 700 }}>
                                    <TableHead>
                                        <TableRow>
                                            <StyledTableCell>Nurse Name</StyledTableCell>
                                            <StyledTableCell sx={{ width: '425px' }}>Phone No</StyledTableCell>
                                            <StyledTableCell sx={{ width: '125px' }}>Start Date</StyledTableCell>
                                            <StyledTableCell sx={{ width: '110px' }}>Duty Days</StyledTableCell>
                                            <StyledTableCell sx={{ width: '150px' }}>Completed Date</StyledTableCell>
                                            <StyledTableCell sx={{ width: '150px' }}>Completed Days</StyledTableCell>
                                            <StyledTableCell sx={{ width: '130px' }}>Salary</StyledTableCell>
                                            <StyledTableCell sx={{ width: '130px' }}>Paid</StyledTableCell>
                                            <StyledTableCell sx={{ width: '130px' }}>Balance</StyledTableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {completedNurses.map((nurseModel) => (
                                            <StyledTableRow key={nurseModel.service_nurse_id.toString()}>
                                                <StyledTableCell component="th" scope="row">
                                                    {nurseModel.nurse_name}
                                                </StyledTableCell>
                                                <StyledTableCell>{GetFullPhoneNo(nurseModel.phone1, nurseModel.phone2, nurseModel.phone3)}</StyledTableCell>
                                                <StyledTableCell>{GetDayJSValueFromUTCDate(nurseModel.start_date).format(DATE_DISPLAY_FORMAT)}</StyledTableCell>
                                                <StyledTableCell>{nurseModel.duty_days}</StyledTableCell>
                                                <StyledTableCell>{GetDayJSValueFromUTCDate(nurseModel.completed_date).format(DATE_DISPLAY_FORMAT)}</StyledTableCell>
                                                <StyledTableCell>{nurseModel.completed_days}</StyledTableCell>
                                                <StyledTableCell>{GetNoToCurrencyFormat(nurseModel.total_salary)}</StyledTableCell>
                                                <StyledTableCell>{GetNoToCurrencyFormat(nurseModel.paid_salary)}</StyledTableCell>
                                                <StyledTableCell>{GetNoToCurrencyFormat(nurseModel.total_salary - nurseModel.paid_salary)}</StyledTableCell>
                                            </StyledTableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Grid>
                    </Grid>
                </Stack>
            </AccordionDetails>
        </Accordion>

    );
}
export default CompletedNurseView;